export function removeWhitespace(value) {
  return value ? value.replace(/\s/g, '') : value;
}

export function toLowerCase(value) {
  return value ? value.toLowerCase() : value;
}

export function toUpperCase(value) {
  return value ? value.toUpperCase() : value;
}

export function replace(value, from, to) {
  return value ? value.replace(from, to) : value;
}



// WEBPACK FOOTER //
// ./src/utils/stringMutation.js